import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {FormValidator} from "../validators/form.validator";

export class LoginValidation {

  static createLoginForm(fb: FormBuilder): FormGroup {
    return fb.group({
      email: ['', [FormValidator.requiredField('Email is required.'), Validators.email, Validators.pattern(/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/)]],
      password: ['', [FormValidator.requiredField('Password is required.')]],
    });
  }
}
